'use client'

import { useTranslations } from 'next-intl'
import { MessageSquare, FileText, Search, Handshake } from 'lucide-react'
import { motion } from 'framer-motion'

const steps = [
  {
    icon: MessageSquare,
    titleKey: 'step1Title',
    descriptionKey: 'step1Description'
  },
  {
    icon: FileText,
    titleKey: 'step2Title',
    descriptionKey: 'step2Description'
  },
  {
    icon: Search,
    titleKey: 'step3Title',
    descriptionKey: 'step3Description'
  },
  {
    icon: Handshake,
    titleKey: 'step4Title',
    descriptionKey: 'step4Description'
  }
]

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
}

const item = {
  hidden: { opacity: 0, scale: 0.95 },
  show: { opacity: 1, scale: 1 }
}

export const HowItWorks = () => {
  const t = useTranslations('howItWorks')

  return (
    <div className="w-full bg-muted/50">
      <section id="how-it-works" className="container py-12 md:py-24">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-12"
        >
          {t('title')}
        </motion.h2>
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8"
        >
          {steps.map((step, index) => {
            const Icon = step.icon
            return (
              <motion.div
                variants={item}
                transition={{ duration: 0.5 }}
                key={index}
                className="flex flex-col items-center text-center p-4 md:p-6 rounded-lg border hover:border-orange-500 transition-colors bg-background"
              >
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-orange-100 dark:bg-orange-900/20 flex items-center justify-center mb-3 md:mb-4">
                  <Icon className="w-6 h-6 md:w-8 md:h-8 text-orange-500" />
                </div>
                <h3 className="text-lg md:text-xl font-semibold mb-2">{t(step.titleKey)}</h3>
                <p className="text-sm md:text-base text-muted-foreground">
                  {t(step.descriptionKey)}
                </p>
              </motion.div>
            )
          })}
        </motion.div>
      </section>
    </div>
  )
}
